<template>
  <div>
    <el-row>
      <el-col>
        <el-alert
          title="Los filtros de Agente, monto y cantidad solo estan disponibles en tab de Pendientes."
          type="info"
          center
          show-icon
          effect="dark"
        ></el-alert>
      </el-col>
    </el-row>
    <rabbey-toolbox>
      <!--
      <div class="mr-5">
        -->
      <!--Propiedades del select -->
      <!--
          v-if="invoicesPending"
          @change="handlerChanges"
        -->
      <!--
        <el-select
          v-model="type"
          placeholder="Tipo"
          class="box-item"
          size="mini"
          v-if="invoicesPending"
        >
          <el-option value="Cantidad">Cantidad</el-option>
          <el-option value="Monto">Monto</el-option>
        </el-select>
      </div>
      -->

      <el-col
        class="mr-5"
        :span="2"
        style="float: right"
        v-if="activeName !== 'Charges2'"
      >
        <el-button
          type="success"
          icon="el-icon-download"
          size="mini"
          style="float: right"
          @click="ExcelExport"
          >Exportar a Excel</el-button
        >
      </el-col>

      <div class="mr-5">
        <el-select
          size="mini"
          v-if="activeName == `invoicesByClient`"
          v-model="value"
          :loading="loading_customers"
          filterable
          clearable
          placeholder="Cliente"
          @change="onClientChanging"
          class="client_select"
        >
          <el-option
            v-for="item in list_customers"
            :key="item.ClientCode"
            :label="item.Name"
            :value="item.ClientCode"
          >
          </el-option>
        </el-select>
      </div>

      <div class="mr-5">
        <el-select
          v-model="Producto"
          placeholder="Producto"
          size="mini"
          v-if="activeName == `invoicesByClient`"
          @change="handleChangeProduct"
        >
          <el-option
            v-for="item in Products"
            :key="item.AccountNumber"
            :label="item.Name"
            :value="item.AccountNumber"
          ></el-option>
        </el-select>
      </div>

      <div class="mr-5">
        <!--Propiedades del select -->
        <!--
          v-if="invoicesPending"
        -->
        <el-select
          v-model="TypeAgent"
          @change="handlerChanges"
          size="mini"
          v-if="false"
        >
          <el-option
            v-for="item in types"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <div class="mr-5" v-if="activeName !== 'Charges2'">
        <yearcomponent @change="handler_year" class="box-item"></yearcomponent>
      </div>
      <el-col class="mr-5" :span="3" style="float: right">
        <ExecutiveSelector
          v-if="
            activeName === 'invoices' ||
            activeName === 'charges' ||
            activeName === 'invoicesPending'
          "
          @OnExecutiveSelected="OnExecutiveSelected"
        />
      </el-col>
    </rabbey-toolbox>

    <!-- INICIO DE LOS TABS -->
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tabs
        type="border-card"
        v-model="activeName"
        @tab-click="handleTabClick"
      >
        <el-tab-pane
          label="Facturados"
          name="invoices"
          :disabled="disableInvoiceTab"
        >
          <el-col :span="24">
            <rabbey-table3
              ref="invoices"
              :loading.sync="principalTable"
              :columns="columnsCharged"
              element-loading-text="Esta consulta puede tardar, por favor esperar."
              :data.sync="items"
              :pageSizes="[10, 20, 30, 40, 100, 500]"
              :page_Size="500"
              :show-summary="true"
              :summary-method="getSummariesMontos"
              @rtable-push-action="HandlerAction"
            />
          </el-col>
        </el-tab-pane>
        <el-tab-pane
          label="Facturados por cliente"
          name="invoicesByClient"
          :disabled="disableInvoiceByClientTab"
        >
          <el-col :span="24">
            <rabbey-table3
              :loading="invoicesByClientLoading"
              :columns="invoiceByClientColumns"
              :stripe="true"
              element-loading-text="Esta consulta puede tardar, por favor esperar."
              :data.sync="items"
              :pageSizes="[10, 20, 30, 40, 100, 500]"
              :page_Size="500"
              :show-summary="true"
              :summary-method="getSummariesMontos"
              @rtable-push-action="HandlerAction"
            />
          </el-col>
        </el-tab-pane>
        <!--Propiedades del tab-pane Cobrados-->
        <!--
          :disabled="disableChargeTab"
        -->

        <!-- <GenericChart
              ref="CobrosMesChart"
              :show="true"

              :url="'/api/accountsReceivable/CobrosChart'"
              :urlParams="{
                Year: this.year,
                Type: 3
              }"
              :title="'Detalles de cobros por mes'"
              :xAxis="daysChart"
            /> -->
        <!-- <GenericChart
              ref="charges"
              :show="true"

              :url="'/api/accountsReceivable/CobrosChart'"
              :urlParams="{
                Year: this.year,
                Type: 3
              }"
              :title="'Detalles de cobros por mes'"
              :xAxis="daysChart"
            /> -->

        <el-tab-pane
          label="Cobrados"
          name="charges"
          :disabled="disableChargeTab"
        >
          <GenericChart
            ref="charges"
            :show="true"
            :reFetchData="changingShow"
            :url="'/api/accountsReceivable/CobrosChart'"
            :urlParams="{
              Year: this.year,
              Type: 3,
              CompanyId: currentCompany,
              TypeAgent: TypeAgent
            }"
            :title="'Detalles de cobros por mes'"
            :xAxis="monthsChart"
            v-if="activeName == `charges`"
          />

          <el-row> </el-row>

          <div>
            <!-- <el-tab-pane
          label="Cobrados"
          name="charges"
          :disabled="disableChargeTab"
          > -->
            <!-- <GenericChart
              ref="charges"
              :show="true"

              :url="'/api/accountsReceivable/CobrosChart'"
              :urlParams="{
                Year: this.year,
                Type: 3
              }"
              :title="'Detalles de cobros por mes'"
              :xAxis="daysChart"
            /> -->
            <!-- </el-tab-pane> -->

            <!-- </el-tabs> -->

            <rabbey-table3
              :loading="disableLoading"
              ref="charges"
              :columns="columnsCharged"
              element-loading-text="Esta consulta puede tardar, por favor esperar."
              :data.sync="items"
              :pageSizes="[10, 20, 30, 40, 100, 500]"
              :page_Size="500"
              :show-summary="true"
              :summary-method="getSummariesMontos"
              @rtable-push-action="HandlerAction"
            />
          </div>
        </el-tab-pane>

        <!-- <el-tabs type="border-card" @tab-click="chartTabClick">
          <el-tab-pane label="Grafico por dias">

          </el-tab-pane> -->

        <!--Propiedades del tab-pane Pendientes-->
        <!--
          :disabled="disablePendingTab"
        -->
        <el-tab-pane
          label="Pendientes"
          name="invoicesPending"
          :disabled="disablePendingTab"
        >
          <rabbey-table3
            :loading="pendingLoading"
            ref="invoicesPending"
            :columns="columnsCharged"
            element-loading-text="Esta consulta puede tardar, por favor esperar."
            :data.sync="itemsPending"
            :pageSizes="[10, 20, 30, 40, 100, 500]"
            :page_Size="500"
            :show-summary="true"
            :summary-method="getSummariesMontos"
            @rtable-push-action="HandlerAction"
          />
        </el-tab-pane>
        <!--Propiedades del tab-pane KPI de Cobros-->
        <!--
          :disabled="disableKpiTab"
        -->
        <el-tab-pane
          label="KPI de Cobros"
          name="KpiCharges"
          :disabled="disableKpiTab"
        >
          <rabbey-table3
            :loading="kpiLoading"
            ref="KpiCharges"
            :columns="columnsKpi"
            element-loading-text="Esta consulta puede tardar, por favor esperar."
            :data.sync="items"
            :pageSizes="[10, 20, 30, 40, 100, 500]"
            :page_Size="500"
            :show-summary="true"
            :summary-method="getSummaries"
            @rtable-push-action="HandlerAction"
          />
        </el-tab-pane>
        <el-tab-pane name="Charges2" label="Cobros 2" :disabled="disableKpiTab">
          <CollectionList></CollectionList>
        </el-tab-pane>
      </el-tabs>
    </el-tabs>
    <!-- FIN DE LOS TABS -->
    <rabbey-base-drawer
      :title="`Detalles de ${tabToTitle[tabDrawer]} del mes de ${monthToSpanish[monthDrawer]}`"
      @close="onCloseDrawer"
      :drawer.sync="detallesFacturas"
      size="80%"
    >
      <el-row>
        <el-col :span="10" :xs="8" :sm="24" :md="24" :lg="10">
          <el-row style="padding: 20px">
            <table style="font-size: 22px" id="table-card">
              <tr>
                <td
                  cellpadding="0"
                  cellspacing="0"
                  style="padding-right: 0px; margin-right: 0px"
                >
                  Facturas:
                </td>
                <td cellpadding="0" cellspacing="0" style="margin-left: 0px">
                  <strong> {{ detallesFacturasItems.length }}</strong>
                </td>
              </tr>
              <tr v-if="activeName != `KpiCharges`">
                <td
                  cellpadding="0"
                  cellspacing="0"
                  style="padding-right: 0px; margin-right: 0px"
                >
                  Monto:
                </td>
                <td cellpadding="0" cellspacing="0" style="margin-left: 0px">
                  <strong> {{ reducerForHeader2 }}</strong>
                </td>
              </tr>
              <tr v-if="activeName == `KpiCharges`">
                <td
                  cellpadding="0"
                  cellspacing="0"
                  style="padding-right: 0px; margin-right: 0px"
                >
                  Monto facturado:
                </td>
                <td cellpadding="0" cellspacing="0" style="margin-left: 0px">
                  <strong> {{ reducerForHeader2 }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>
        <el-col :span="10" :xs="8" :sm="24" :md="24" :lg="10">
          <el-row style="padding: 20px">
            <table style="font-size: 22px" id="table-card">
              <tr v-if="activeName == `KpiCharges`">
                <td
                  cellpadding="0"
                  cellspacing="0"
                  style="padding-right: 0px; margin-right: 0px"
                >
                  Monto cobrado:
                </td>
                <td cellpadding="0" cellspacing="0" style="margin-left: 0px">
                  <strong> {{ kpiCobradoPorMes }}</strong>
                </td>
              </tr>
              <tr v-if="activeName == `KpiCharges`">
                <td
                  width="50%"
                  cellpadding="0"
                  cellspacing="0"
                  style="padding-right: 0px; margin-right: 0px"
                >
                  Monto pendiente:
                </td>
                <td cellpadding="0" cellspacing="0" style="margin-left: 0px">
                  <strong> {{ kpiPendientePorMes }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>
      </el-row>
      <el-row v-if="activeName == 'charges'">
        <el-tabs type="border-card" @tab-click="chartTabClick">
          <el-tab-pane label="Grafico por dias">
            <GenericChart
              ref="CobrosMesChart"
              :show="showChartMonth"
              :url="'/api/accountsReceivable/CobrosChart'"
              :urlParams="{
                Year: year,
                Month: monthToNumber[monthDrawer],
                Type: 1,
                CompanyId: currentCompany,
                TypeAgent: TypeAgent
              }"
              :title="'Detalles de cobros por dia'"
              :xAxis="daysChart"
            />
          </el-tab-pane>
          <el-tab-pane label="Grafico por semanas" name="semana">
            <GenericChart
              ref="CobrosMesChart2"
              :show="showChartMonth2"
              :url="'/api/accountsReceivable/CobrosChart'"
              :urlParams="{
                Year: year,
                Month: monthToNumber[monthDrawer],
                Type: 2,
                CompanyId: currentCompany,
                TypeAgent: TypeAgent
              }"
              :title="'Detalles de cobros por semana'"
              :xAxis="weeksChart"
              :startsWith="'week'"
            />
          </el-tab-pane>
        </el-tabs>
      </el-row>
      <el-row>
        <el-col>
          <rabbey-table3
            ref="table"
            :search="detailSearch"
            :loading.sync="cargandoDetallesFacturas"
            :actions="actions"
            :columns="detallesFacturasColumns"
            :data="detallesFacturasItems"
            @rtable-push-action="HandlerAction"
            :TabActiveName="activeName"
          />
        </el-col>
      </el-row>
    </rabbey-base-drawer>
    <!-- table detalle por agentes -->
    <rabbey-base-drawer
      :title="`Reporte de detalle de ${datailTitle}`"
      :drawer.sync="cobros"
      size="80%"
      @close="onCloseDrawer"
    >
      <el-row>
        <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
          <el-row style="padding: 20px">
            <table style="font-size: 22px" id="table-card">
              <tr>
                <td
                  width="10%"
                  cellpadding="0"
                  cellspacing="0"
                  style="padding-right: 0px; margin-right: 0px"
                >
                  Ejecutivo:
                </td>
                <td cellpadding="0" cellspacing="0" style="margin-left: 0px">
                  <strong> {{ executive }}</strong>
                </td>
              </tr>
              <tr>
                <td
                  width="10%"
                  cellpadding="0"
                  cellspacing="0"
                  style="padding-right: 0px; margin-right: 0px"
                >
                  Facturas:
                </td>
                <td cellpadding="0" cellspacing="0" style="margin-left: 0px">
                  <strong> {{ registers.length }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>

        <el-col :span="8" :xs="3" :sm="24" :md="24" :lg="8">
          <el-row style="padding: 20px">
            <table style="font-size: 22px" id="table-card">
              <tr>
                <td width="10%">Año:</td>
                <td>
                  <strong> {{ year }}</strong>
                </td>
              </tr>
              <tr>
                <td width="10%">Monto:</td>
                <td>
                  <strong> {{ reducerForHeader }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>
        <el-col :span="3" :xs="3" :sm="24" :md="24" :lg="3">
          <el-row style="padding: 20px">
            <table style="font-size: 22px" id="table-card">
              <tr>
                <td width="10%">Mes:</td>
                <td>
                  <strong> {{ month }}</strong>
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>
      </el-row>
      <el-row
        v-if="activeName == `KpiCharges`"
        style="padding: 0px; margin: 0px"
      >
        <el-col :span="7" :xs="7" :sm="24" :md="24" :lg="10">
          <el-row style="padding: 20px">
            <table style="font-size: 20px" id="table-card">
              <tr style="font-size: 20px">
                <td width="60%">Monto Facturas del mes actual:</td>
                <td>
                  <strong> {{ formatMonto(Totalinvoiced()) }}</strong>
                </td>
              </tr>
              <tr>
                <td width="60%">Monto Pendiente del meses:</td>
                <td>
                  <strong> {{ formatMonto(TotalPendinginmoth) }}</strong>
                </td>
              </tr>
              <tr style="font-size: 20px">
                <td width="60%">Monto Cobrado del mes:</td>
                <td>
                  <strong> {{ formatMonto(TotalchargedinMoth()) }}</strong>
                </td>
              </tr>
              <tr style="font-size: 20px">
                <td width="60%">Monto Cobrado de meses anteriores:</td>
                <td>
                  <strong>
                    {{
                      formatMonto(TotalchargedThisMonthFromPastFacts())
                    }}</strong
                  >
                </td>
              </tr>
              <tr style="font-size: 20px">
                <td width="60%">KPI del Mes:</td>
                <td>
                  <el-tag
                    :type="efficiencyPercentageColor"
                    style="font-size: 20px"
                    >{{ efficiencyPercentage }}</el-tag
                  >
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>
        <el-col :span="7" :xs="7" :sm="24" :md="24" :lg="10">
          <el-row style="padding: 20px">
            <table style="font-size: 20px" id="table-card">
              <tr style="font-size: 20px">
                <td width="40%">Facturas Emitidas:</td>
                <td>
                  <strong> {{ Cant }}</strong>
                </td>
              </tr>
              <tr style="font-size: 20px">
                <td width="40%">Facturas cobrada:</td>
                <td>
                  <strong> {{ Invoicecollected }}</strong>
                </td>
              </tr>
              <tr style="font-size: 20px">
                <td width="40%">Facturas pendientes:</td>
                <td>
                  <strong> {{ Pendinginvoices }}</strong>
                </td>
              </tr>
              <tr style="font-size: 20px">
                <td width="40%">KPI Acumulado:</td>
                <td>
                  <el-tag
                    :type="AcumulatedefficiencyPercentageColor"
                    style="font-size: 20px"
                    >{{ AcumulatedefficiencyPercentage }}</el-tag
                  >
                </td>
              </tr>
            </table>
          </el-row>
        </el-col>
      </el-row>
      <el-row v-if="activeName == 'charges'">
        <el-tabs type="border-card" @tab-click="chartTabClick2">
          <el-tab-pane label="Grafico por dias">
            <GenericChart
              ref="CobrosEjecutivoChart"
              :show="showChartEjecutiveMonth"
              :url="'/api/accountsReceivable/CobrosChart'"
              :urlParams="{
                Year: year,
                Month: monthToNumber[month],
                ExecutiveCode: ejecutive ? ejecutive.Code : null,
                Type: 1,
                CompanyId: currentCompany,
                TypeAgent: TypeAgent
              }"
              :title="'Detalles de cobros por dia'"
              :xAxis="daysChart"
            />
          </el-tab-pane>
          <el-tab-pane label="Grafico por semanas" name="semana">
            <GenericChart
              ref="CobrosEjecutivoChart2"
              :show="showChartEjecutiveMonth2"
              :url="'/api/accountsReceivable/CobrosChart'"
              :urlParams="{
                Year: year,
                Month: monthToNumber[month],
                ExecutiveCode: ejecutive ? ejecutive.Code : null,
                Type: 2,
                CompanyId: currentCompany,
                TypeAgent: TypeAgent
              }"
              :title="'Detalles de cobros por semana'"
              :xAxis="weeksChart"
              :startsWith="'week'"
            />
          </el-tab-pane>
        </el-tabs>
      </el-row>
      <!-- <el-row>
        <GenericChart
          ref="CobrosEjecutivoChart"
          :show="showChartEjecutiveMonth"
          :url="'/api/accountsReceivable/CobrosChart'"
          :urlParams="{
            Year: year,
            ExecutiveCode: ejecutive ? ejecutive.Code : null,
            Month: monthToNumber[month]
          }"
          :title="'Detalles de cobros por ejecutivo'"
          :xAxis="daysChart"
        />
      </el-row> -->
      <rabbey-toolbox filterables @filter-search="detailSearch = $event">
        <SletectQuincena
          :defaulValue="quincenaSelected"
          @QuincenaSelected="onQuincenaSelected"
        />
      </rabbey-toolbox>

      <el-row>
        <el-col>
          <rabbey-table3
            ref="table"
            :search="detailSearch"
            :loading.sync="loadingDetails"
            :actions="actions"
            :columns="columnsDetails2"
            :data="RegistersFilteredByBiweekly"
            @rtable-push-action="HandlerAction"
            :TabActiveName="activeName"
          />
        </el-col>
      </el-row>

      <el-drawer
        title="Cambio de fecha de pago"
        :append-to-body="true"
        :before-close="handleClose"
        :visible.sync="formpayment"
        size="25%"
      >
        <hr />
        <el-container>
          <el-main>
            <el-row>
              <el-col>
                <el-form
                  ref="form"
                  label-width="120px"
                  v-model="form"
                  label-position="top"
                >
                  <el-form-item label="Contacto">
                    <el-select
                      v-model="form.contactName"
                      v-loading="loadingContacts"
                      placeholder="Contactos"
                      style="width: 100%"
                      @change="handleContactSelect"
                    >
                      <el-option
                        style="width: 100%"
                        v-for="item in contacts"
                        :key="item.Code"
                        :label="item.FullName"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="Teléfono">
                    <el-input
                      placeholder="Teléfono"
                      v-model="form.contactNumber"
                      style="width: 100%"
                      disabled
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Celular">
                    <el-input
                      placeholder="Celular"
                      v-model="form.contactPhoneNumber"
                      style="width: 100%"
                      disabled
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Correo">
                    <el-input
                      placeholder="Correo"
                      v-model="form.contactEmail"
                      style="width: 100%"
                      disabled
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="Fecha de Pago">
                    <el-date-picker
                      type="date"
                      placeholder="Fecha Original"
                      v-model="form.currentdate"
                      disabled
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>

                  <el-form-item label="Nueva Fecha Promesa de Pago">
                    <el-date-picker
                      type="date"
                      placeholder="Nueva Fecha"
                      v-model="form.newdate"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>

                  <el-form-item label="Motivo de Promesa de Pago">
                    <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="Comentario"
                      v-model="form.comment"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                      type="primary"
                      :loading="handleButtonLoading"
                      :disabled="!isValid"
                      size="mini"
                      @click="onSubmit"
                      >Guardar cambios</el-button
                    >
                    <el-button @click="handleClose" size="mini"
                      >Cancelar</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-drawer>

      <el-drawer
        title="Comentarios"
        :visible.sync="Dcoments"
        :append-to-body="true"
        size="45%"
      >
        <el-container>
          <el-main>
            <el-row>
              <el-col>
                <rabbey-table3
                  ref="table2"
                  :columns="columnsComments"
                  v-loading="loadingDetails"
                  :before-close="handleClose"
                  :data="comments"
                />
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-drawer>

      <el-drawer
        title="Detalles de documentos"
        :visible.sync="entryDocDrawer"
        :append-to-body="true"
        size="60%"
      >
        <el-container>
          <el-main>
            <el-row>
              <el-col>
                <rabbey-table3
                  ref="documentDetails"
                  :columns="columnsDetailsEntry"
                  v-loading="loadingDetails"
                  :before-close="handleClose"
                  :data="itemEntryDetails"
                />
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-drawer>
    </rabbey-base-drawer>

    <CustomerDetail
      ref="detailsCustomer"
      :append-to-body="true"
      :CustomerData="customerDetailData"
    />
  </div>
</template>

<script>
import { daysChart, weeksChart, monthsChart } from "@/chartUtils.js";
import GenericChart from "@/views/Charts/GenericChart.vue";
import PerfilPerson from "@/components/functionals/PerfilPerson.vue";
import { Decimal } from "decimal.js";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import { GetMonthInLetterBeginingOnZero, formatMonto } from "../../../../utils";
import { MONTHS_LIST } from "@/const";
import yearcomponent from "@/components/Global_System/YearsComponent";
import { PaymentDetails, commentColumns } from "@/helpers/MonthsColumns";
import HyperLinkColumnPendiente from "@/components/functionals/HyperLinkColumnPendiente.vue";
import HyperLink from "@/components/functionals/HyperLink.vue";
import HyperLinkTab from "@/components/functionals/HyperLinkTab.vue";
import ColorTypeInvoiceByClient from "@/components/functionals/ColorTypeInvoiceByClient.vue";
import CustomerDetail from "@/components/customers/CustomerDetail.vue";
// import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
// import ColorTagsinLineFormatter from "@/components/functionals/ColorTagsinLineFormatter.vue";
// import ImagePerson from "@/components/functionals/ImagePerson.vue";
// import SLAClolorStatus from "@/components/functionals/SLAClolorStatus";
// import DatetimeCobroFormatter from "@/components/functionals/DatetimeColorCobroFormatter.vue";
import {
  invoicesColumns,
  chargesColumns,
  KpiChargesColumns,
  pendingColumns
} from "@/views/modules/finances/collections/ChargesColumns.js";
import { getColumns } from "@/views/modules/finances/collections/detailsMonthTabColumns.js";
//import { formatterMoney } from "@/utils";
//import ColorTypeColumnPendiente from "@/components/functionals/ColorTypeColumnPendiente.vue";
import CollectionList from "@/views/modules/finances/collections/CollectionList";
import SletectQuincena from "@/components/Selects/SletectQuincena";
import { exportExcel } from "@/helpers/exportExcel";
import ExecutiveSelector from "@/views/modules/finances/collections/filters/ExecutiveSelector";

export default {
  name: "ChargesTab",
  components: {
    yearcomponent,
    CustomerDetail,
    CollectionList,
    GenericChart,
    SletectQuincena,
    ExecutiveSelector
  },
  computed: {
    kpiCobradoPorEjecutivo() {
      let total = new Decimal(0.0);
      this.detallesFacturasItems
        .filter((f) => f.DocumentType == 1)
        .forEach((f) => {
          if (f.Amount) {
            total = total.plus(Math.abs(f.Amount));
          }
        });
      return formatMonto(total.toNumber());
    },
    kpiPendientePorEjecutivo() {
      let total = new Decimal(0.0);
      this.detallesFacturasItems
        .filter((f) => f.DocumentType == 2)
        .forEach((f) => {
          if (f.Amount) {
            total = total.plus(Math.abs(f.Amount));
          }
        });
      return formatMonto(total.toNumber());
    },
    kpiCobradoPorMes() {
      let total = new Decimal(0.0);
      this.detallesFacturasItems
        .filter((f) => f.DocumentType == 1)
        .forEach((f) => {
          if (f.Amount) {
            total = total.plus(f.Amount);
          }
        });
      return formatMonto(total.toNumber());
    },
    kpiPendientePorMes() {
      let total = new Decimal(0.0);
      this.detallesFacturasItems
        .filter((f) => f.DocumentType == 2)
        .forEach((f) => {
          if (f.Amount) {
            total = total.plus(f.Amount);
          }
        });
      return formatMonto(total.toNumber());
    },
    reducerForHeader2() {
      let total = new Decimal(0.0);
      this.detallesFacturasItems.forEach((r) => {
        if (r.Amount) {
          total = total.plus(r.Amount);
        }
      });
      return formatMonto(total.toNumber());
    },
    reducerForHeader() {
      let total = new Decimal(0.0);
      this.registers.forEach((r) => {
        if (r.Amount) {
          total = total.plus(r.Amount);
        }
      });
      return formatMonto(Math.abs(total.toNumber()));
    },
    detallesFacturasColumns() {
      return getColumns(this.tabToType[this.tabDrawer]);
    },
    ...mapState("my_request", [
      "swichMyRequest",
      "tabActiveName",
      "search",
      // "loading",
      "sectionSelected"
    ]),
    ...mapGetters({
      list_customers: "customers/list_to_select",
      loading_customers: "customers/isLoading"
    }),
    activeName: {
      get() {
        return this.tabActiveName == "new" ? "invoices" : this.tabActiveName;
      },
      set(val) {
        this.SET_TAB_ACTIVE_NAME(val);
      }
    },
    isValid: function () {
      return this.form.comment.trim().length > 5 && this.form.newdate !== null;
    },
    Cant: function () {
      return this.registers.length;
    },
    Invoicecollected: function () {
      return this.registers.filter(
        (kpi) => kpi.ClosedDate != "1753-01-01T00:00:00"
      ).length;
      // return this.registers.filter((kpi) => kpi.DocumentType == 1).length;
    },
    Pendinginvoices: function () {
      return this.registers.filter(
        (kpi) => kpi.ClosedDate == "1753-01-01T00:00:00"
      ).length;
    },
    efficiencyPercentageColor() {
      if (this.efficiencyPercentage.replace("%", "") <= 70) {
        return "danger";
      } else if (this.efficiencyPercentage.replace("%", "") >= 90) {
        return "success";
      } else if (
        this.efficiencyPercentage.replace("%", "") >= 71 &&
        this.efficiencyPercentage.replace("%", "") <= 89
      ) {
        return "warning";
      }
      return "info";
    },
    AcumulatedefficiencyPercentageColor() {
      if (this.AcumulatedefficiencyPercentage.replace("%", "") <= 70) {
        return "danger";
      } else if (this.AcumulatedefficiencyPercentage.replace("%", "") >= 90) {
        return "success";
      } else if (
        this.AcumulatedefficiencyPercentage.replace("%", "") >= 71 &&
        this.AcumulatedefficiencyPercentage.replace("%", "") <= 89
      ) {
        return "warning";
      }
      return "info";
    },
    TotalG: function () {
      // if (this.registers.length <= 0) {
      //   return 0;
      // }

      return this.registers
        .filter((item) => item.Amount != null)
        .map((item) => item.Amount)
        .reduce((a, c) => a + c, 0);
    },

    mapColumns() {
      let columns = this.columns;
      for (let i = 0; i < 12; i++) {
        const month = MONTHS_LIST[i];
        columns.push({
          prop: month,
          label: this.$t(`months.${month}`),
          name: this.$t(`months.${month}`),
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: i + 1
          },
          formatter: HyperLinkColumnPendiente
        });
      }

      columns.push({
        prop: "Totals",
        label: "Total",
        name: "Total",
        attrs: {
          isTotal: true,
          OpenSelection: this.OpenSelection,
          getType: this.getType,
          month: 0
        },
        formatter: HyperLinkColumnPendiente
      });
      return columns;
    },
    TotalPending() {
      const factured =
        this.registers.length > 0 ? this.registers[0].Pendientes : 0;
      // let factured = this.registers
      //   .filter((kpi) => kpi.DocumentType == 2)
      //   .map((item) => item.Amount)
      //   .reduce((prev, curr) => new Decimal(prev).plus(curr).toNumber(), 0);

      //let facturedformated = formatMonto(factured);
      return factured;
    },
    TotalPendinginmoth() {
      const factured =
        this.registers.length > 0 ? this.registers[0].Pendientes_del_mes : 0;
      // let factured = this.registers
      //   .filter((kpi) => kpi.DocumentType == 2)
      //   .map((item) => item.Amount)
      //   .reduce((prev, curr) => new Decimal(prev).plus(curr).toNumber(), 0);

      //let facturedformated = formatMonto(factured);
      return factured;
    },

    efficiencyPercentage() {
      let cobrados = new Decimal(this.TotalchargedinMoth());
      let facturados = new Decimal(this.Totalinvoiced());
      let eficiencia = cobrados.dividedBy(facturados);
      eficiencia = eficiencia.mul(100);
      eficiencia = eficiencia > 100 ? 100 : eficiencia;
      //let eficiencia = cobrados.dividedBy(total).absoluteValue()

      return `${eficiencia.toFixed(2)} %`;
    },

    AcumulatedefficiencyPercentage() {
      let cobradosAnteriores = new Decimal(
        this.TotalchargedThisMonthFromPastFacts()
      );
      let facturados = this.Totalinvoiced();
      let pendientes = this.TotalPendinginmoth;
      let sumfactured = new Decimal(Number(facturados) + Number(pendientes));
      let eficiencia = cobradosAnteriores.dividedBy(sumfactured);
      eficiencia = eficiencia.mul(100);

      eficiencia = eficiencia > 100 ? 100 : eficiencia;
      //let eficiencia = cobrados.dividedBy(total).absoluteValue()

      return `${eficiencia.toFixed(2)} %`;
    },
    RegistersFilteredByBiweekly() {
      let newRegisters = [];
      switch (this.quincenaSelected) {
        case 1:
          newRegisters = this.registers.filter(
            (r) => new Date(r.DueDate).getDate() <= 14
          );
          break;
        case 15:
          newRegisters = this.registers.filter(
            (r) => new Date(r.DueDate).getDate() >= 15
          );
          break;

        default:
          newRegisters = this.registers;
          break;
      }
      return newRegisters;
    }
  },
  data() {
    return {
      options: [{ value: "hola", label: "hola" }],
      semana: false,
      ejecutive: null,
      daysChart,
      weeksChart,
      monthsChart,
      changingShow: true,
      showChartMonth: false,
      showChartMonth2: false,
      showChartEjecutiveMonth: false,
      showChartEjecutiveMonth2: false,
      amountNameForReducerHeader: "AmountInDollars",
      tabDrawer: "invoices",
      monthDrawer: "January",
      detallesFacturas: false,
      cargandoDetallesFacturas: false,
      detallesFacturasItems: [],
      customerDetailData: {},
      tabToTitle: {
        invoices: "Facturados",
        invoicesByClient: "Facturados por clientes",
        charges: "Cobrados",
        invoicesPending: "Pendientes",
        KpiCharges: "KPI Cobros"
      },
      tabToType: {
        invoices: 2,
        invoicesByClient: 2,
        charges: 1,
        invoicesPending: 3,
        KpiCharges: 4
      },
      monthToNumber: {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12
      },
      monthToSpanish: {
        January: "Enero",
        February: "Febrero",
        March: "Marzo",
        April: "Abril",
        May: "Mayo",
        June: "Junio",
        July: "Julio",
        August: "Agosto",
        September: "Septiembre",
        October: "Octubre",
        November: "Noviembre",
        December: "Diciembre"
      },
      summaryMonth: {},
      dataClients: [],
      datailTitle: "",
      loading: false,
      invoicesByClientLoading: false,
      kpiLoading: false,
      invoicesPending: "",
      activeTab: "invoices",
      detailSearch: "",
      principalTable: false,
      loadingDetails: false,
      cobros: false,
      formpayment: false,
      year: new Date().getFullYear(),
      value: "",
      TypeAgent: "accountingmanager",
      type: "Monto",
      executive: "",
      contacts: [],
      loadingContacts: false,
      month: "",
      AccountNumber: "",
      Amount: 0,
      InvoiceNum: "",
      ContactEmail: "",
      Products: [],
      Producto: "",
      form: {
        currentdate: "",
        newdate: "",
        comment: "",
        contactName: "",
        contactData: "",
        contactEmail: "",
        contactNumber: "",
        contactPhoneNumber: ""
      },
      types: [
        { value: "vendor", label: "Vendedor" },
        { value: "customerservice", label: "Servicio al Cliente" },
        { value: "accountingmanager", label: "Cuenta por Cobrar" }
      ],
      columns: [
        {
          prop: "ExecutiveName",
          label: "Ejecutivo",
          minWidth: 220,
          fixed: true
        }
      ],

      invoiceByClientColumns: [
        {
          prop: "ClientCode",
          label: "No.",
          minWidth: 100,
          fixed: true
        },
        {
          prop: "ClientName",
          label: "Nombre",
          minWidth: 210,
          fixed: true
        },
        {
          prop: "January",
          label: this.$t(`months.January`),
          name: this.$t(`months.January`),
          sortable: true,
          minWidth: 150,

          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 1
          },
          formatter: ColorTypeInvoiceByClient
        },
        {
          prop: "February",
          label: "Febrero",
          sortable: true,
          minWidth: 150,

          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 2
          },
          formatter: ColorTypeInvoiceByClient
        },
        {
          prop: "March",
          label: "Marzo",
          sortable: true,
          minWidth: 150,

          name: "March",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 3
          },
          formatter: ColorTypeInvoiceByClient
        },
        {
          prop: "April",
          label: "Abril",
          sortable: true,
          minWidth: 150,

          name: "April",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 4
          },
          formatter: ColorTypeInvoiceByClient
        },
        {
          prop: "May",
          label: "Mayo",
          sortable: true,
          minWidth: 150,

          name: "May",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 5
          },
          formatter: ColorTypeInvoiceByClient
        },
        {
          prop: "June",
          label: "Junio",
          sortable: true,
          minWidth: 150,

          name: "Junio",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 6
          },
          formatter: ColorTypeInvoiceByClient
        },
        {
          prop: "July",
          label: "Julio",
          sortable: true,
          minWidth: 150,

          name: "Julio",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 7
          },
          formatter: ColorTypeInvoiceByClient
        },
        {
          prop: "August",
          label: "August",
          sortable: true,
          minWidth: 150,

          name: "August",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 8
          },
          formatter: ColorTypeInvoiceByClient
        },
        {
          prop: "September",
          label: "September",
          sortable: true,
          minWidth: 150,

          name: "September",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 9
          },
          formatter: ColorTypeInvoiceByClient
        },
        {
          prop: "October",
          label: "October",
          sortable: true,
          minWidth: 150,

          name: "October",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 10
          },
          formatter: ColorTypeInvoiceByClient
        },
        {
          prop: "November",
          label: "November",
          sortable: true,
          minWidth: 150,

          name: "November",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 11
          },
          formatter: ColorTypeInvoiceByClient
        },
        {
          prop: "December",
          label: "December",
          sortable: true,
          minWidth: 150,

          name: "December",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 12
          },
          formatter: ColorTypeInvoiceByClient
        },
        {
          prop: "Total",
          label: "Total",
          minWidth: 150
        },
        {
          prop: "ClientReceivable",
          label: "Ejecutivo",
          minWidth: 110
        },
        {
          prop: "ClientService",
          label: "Servicio cliente",
          minWidth: 110
        },
        {
          prop: "SalesPerson",
          label: "Vendedor",
          minWidth: 220
        }
      ],
      columnsCharged: [
        {
          prop: "Person",
          label: "Ejecutivo",
          minWidth: 240,
          fixed: true,
          formatter: PerfilPerson
        },
        {
          prop: "January",
          label: this.$t(`months.January`),
          name: this.$t(`months.January`),
          minWidth: 120,

          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 1
          },
          formatter: HyperLinkTab
        },
        {
          prop: "February",
          label: "Febrero",
          minWidth: 120,

          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 2
          },
          formatter: HyperLinkTab
        },
        {
          prop: "March",
          label: "Marzo",
          minWidth: 120,

          name: "March",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 3
          },
          formatter: HyperLinkTab
        },
        {
          prop: "April",
          label: "Abril",
          minWidth: 120,

          name: "April",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 4
          },
          formatter: HyperLinkTab
        },
        {
          prop: "May",
          label: "Mayo",
          minWidth: 120,

          name: "May",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 5
          },
          formatter: HyperLinkTab
        },
        {
          prop: "June",
          label: "Junio",
          minWidth: 120,

          name: "Junio",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 6
          },
          formatter: HyperLinkTab
        },
        {
          prop: "July",
          label: "Julio",
          minWidth: 120,

          name: "Julio",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 7
          },
          formatter: HyperLinkTab
        },
        {
          prop: "August",
          label: "August",
          minWidth: 120,

          name: "August",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 8
          },
          formatter: HyperLinkTab
        },
        {
          prop: "September",
          label: "September",
          minWidth: 120,

          name: "September",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 9
          },
          formatter: HyperLinkTab
        },
        {
          prop: "October",
          label: "October",
          minWidth: 120,

          name: "October",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 10
          },
          formatter: HyperLinkTab
        },
        {
          prop: "November",
          label: "November",
          minWidth: 120,

          name: "November",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 11
          },
          formatter: HyperLinkTab
        },
        {
          prop: "December",
          label: "December",
          minWidth: 120,

          name: "December",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 12
          },
          formatter: HyperLinkTab
        },
        {
          prop: "Totals",
          label: "Total",
          minWidth: 120
        }
      ],
      columnsKpi: [
        {
          prop: "ExecutiveName",
          label: "Ejecutivo",
          minWidth: 240,
          fixed: true,
          formatter: PerfilPerson
        },
        {
          prop: "January",
          label: this.$t(`months.January`),
          name: this.$t(`months.January`),
          minWidth: 150,

          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 1
          },
          formatter: HyperLink
        },
        {
          prop: "February",
          label: "Febrero",
          minWidth: 150,

          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 2
          },
          formatter: HyperLink
        },
        {
          prop: "March",
          label: "Marzo",
          minWidth: 150,

          name: "March",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 3
          },
          formatter: HyperLink
        },
        {
          prop: "April",
          label: "Abril",
          minWidth: 150,

          name: "April",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 4
          },
          formatter: HyperLink
        },
        {
          prop: "May",
          label: "Mayo",
          minWidth: 150,

          name: "May",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 5
          },
          formatter: HyperLink
        },
        {
          prop: "June",
          label: "Junio",
          minWidth: 150,

          name: "Junio",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 6
          },
          formatter: HyperLink
        },
        {
          prop: "July",
          label: "Julio",
          minWidth: 150,

          name: "Julio",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 7
          },
          formatter: HyperLink
        },
        {
          prop: "August",
          label: "August",
          minWidth: 150,

          name: "August",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 8
          },
          formatter: HyperLink
        },
        {
          prop: "September",
          label: "September",
          minWidth: 150,

          name: "September",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 9
          },
          formatter: HyperLink
        },
        {
          prop: "October",
          label: "October",
          minWidth: 150,

          name: "October",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 10
          },
          formatter: HyperLink
        },
        {
          prop: "November",
          label: "November",
          minWidth: 150,

          name: "November",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 11
          },
          formatter: HyperLink
        },
        {
          prop: "December",
          label: "December",
          minWidth: 150,

          name: "December",
          attrs: {
            OpenSelection: this.OpenSelection,
            getType: this.getType,
            month: 12
          },
          formatter: HyperLink
        }
      ],
      columnsDetails2: [
        /*
        {
          prop: "EntryNo",
          label: "No. Registro",
          minWidth: 130,
          sortable: true,
          attrs: {
            OpenEntryDetails: this.OpenEntryDetails,
            getType: this.getType,
            month: 24
          },
          formatter: HyperLink
        },
        */
        // {
        //   prop: "DocumentNo",
        //   label: "No. Factura",
        //   align: "center",
        //   minWidth: 110,
        //   attrs: {
        //     OpenEntryDetails: this.OpenEntryDetails,
        //     getType: this.getType,
        //     month: 24
        //   },
        //   formatter: HyperLink
        // },
        // {
        //   prop: "PostingDate",
        //   label: "Fecha de Factura",
        //   minWidth: 130,
        //   formatter: DatetimeFormatter
        // },
        // {
        //   prop: "Customer",
        //   label: "Cliente",
        //   minWidth: 250
        // },
        // {
        //   prop: "ExecutiveName",
        //   label: "Ejecutivo de Cobros",
        //   minWidth: 200,
        //   formatter: ImagePerson,
        //   sortable: true,
        //   attrs: {
        //     imgKey: "accountPhotoExec"
        //   },
        //   noMapped: true
        //   // formatter: row => formatMonto(Number(row.Amount))
        // },
        // {
        //   prop: "AmountInDollars",
        //   label: "Monto",
        //   sortable: true,
        //   minWidth: 120
        //   // formatter: row => formatMonto(Number(row.Amount))
        // },
        // {
        //   prop: "ClosedDate",
        //   label: "Fecha de Cobro",
        //   width: 170,
        //   formatter: DatetimeCobroFormatter
        // },
        // {
        //   prop: "DocumentType",
        //   label: "Estatus",
        //   sortable: true,
        //   minWidth: 120,
        //   formatter: ColorTagsinLineFormatter
        // },
        // {
        //   prop: "DueDate",
        //   label: "Fecha de compromiso",
        //   width: 170,
        //   formatter: DatetimeFormatter
        // },
        // {
        //   prop: "DaysLate",
        //   label: "Dias de Retraso",
        //   align: "center",
        //   minWidth: 150,
        //   formatter: SLAClolorStatus
        // },
        // /*
        // {
        //   prop: "ChargeDocument",
        //   label: "Documento de cobro",
        //   minWidth: 150
        // },
        // */
        // {
        //   prop: "Contact",
        //   label: "Contacto",
        //   minWidth: 150,
        //   noMapped: true
        // },
        // {
        //   prop: "Description",
        //   label: "Descripcion",
        //   minWidth: 250
        // },
        // {
        //   prop: "LatestComment",
        //   label: "Último Comentario",
        //   minWidth: 250,
        //   noMapped: true
        // },
        // {
        //   prop: "PromiseDate",
        //   label: "Promesa de pago",
        //   minWidth: 140,
        //   formatter: DatetimeFormatter,
        //   noMapped: true
        // }
        // // {
        // //   prop: "CreatedBy",
        // //   label: "Usuario",
        // //   minWidth: 150
        // // }
      ],
      columnsDetailsEntry: [
        {
          prop: "EntryNo",
          label: "No. Registro",
          width: 100
        },
        {
          prop: "DocumentNo",
          label: "Documento",
          minWidth: 100
        },
        {
          prop: "PostingDate",
          label: "Fecha",
          minWidth: 85
        },
        {
          prop: "CustomerNo",
          label: "Código de Cliente",
          minWidth: 150
        },
        {
          prop: "Customer",
          label: "Cliente",
          minWidth: 250
        },
        {
          prop: "DebitAmount",
          label: "Debito",
          minWidth: 150
        },
        {
          prop: "CreditAmount",
          label: "Credito",
          minWidth: 150
        },
        {
          prop: "Description",
          label: "Descripcion",
          minWidth: 150
        },
        {
          prop: "TransactionNo",
          label: "Número de transacción",
          minWidth: 200
        }
      ],
      columnsDetails: [...PaymentDetails],
      columnsComments: [...commentColumns],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver Perfil del Cliente",
          command: "view-customer"
        },
        {
          icon: "el-icon-date",
          label: "Cambiar fecha de pago",
          command: "change-date-payment",
          condition: () => this.activeName == "invoicesPending"
        },
        {
          icon: "el-icon-chat-line-square",
          label: "Ver Comentarios de Interacciones",
          command: "see-comments"
        },
        {
          icon: "el-icon-chat-line-square",
          label: "Ver Comentarios de Cobro",
          command: "see-comments-payment"
        }
      ],
      items: [],
      itemsInvoices: [],
      itemsInvoicesByClient: [],
      itemsCharged: [],
      itemsPending: [],
      itemsKpi: [],
      itemsDetails: [],
      registers: [],
      itemEntryDetails: [],
      comments: [],
      Dcoments: false,
      entryDocDrawer: false,
      commentloading: false,
      request: null, // Seguimiento de solicitud, para su cancelacion.
      disableInvoiceTab: false,
      disableInvoiceByClientTab: false,
      disablePendingTab: true,
      disableKpiTab: true,
      disableChargeTab: true,
      pendingLoading: false,
      disableLoading: false,
      handleButtonLoading: false,
      selectedRow: {},
      clientCode: null,
      quincenaSelected: 0
    };
  },
  mounted() {
    this.principalTable = true;

    this.getData();
    this.getProducts();
    // this.getDataCharged();
    // this.getDataPending();
    // this.getKPI();
  },
  created() {
    this.principalTable = true;
  },
  methods: {
    getProducts() {
      this.$http
        .get("/api/accountsReceivable/GetProductsTennos")
        .then((resp) => {
          this.Products = resp.data;
        })
        .finally(() => {
          this.autoLoading = false;
        });
    },
    handleChangeProduct(product) {
      this.Producto = product;
      this.getInvoicesByClient();
    },
    chartTabClick(tab) {
      if (tab.name == "semana") {
        this.showChartMonth2 = true;
        this.semana = true;
        return;
      }
      this.showChartMonth = true;
      this.semana = false;
    },
    chartTabClick2(tab) {
      if (tab.name == "semana") {
        this.showChartEjecutiveMonth2 = true;
        this.semana = true;
        return;
      }
      this.showChartEjecutiveMonth = true;
      this.semana = false;
    },
    Totalinvoiced() {
      const factured =
        this.registers.length > 0 ? this.registers[0].Facturados : 0;
      // const factured = this.registers
      //   //.filter(kpi => kpi.DocumentType == 2)
      //   .map((item) => item.Amount)
      //   .reduce((prev, curr) => new Decimal(prev).plus(curr).toNumber(), 0);

      return factured;
    },
    Totalcharged() {
      const charged =
        this.registers.length > 0 ? this.registers[0].Cobrados : 0;
      // const charged = Math.abs(
      //   this.registers
      //     .filter((kpi) => kpi.DocumentType == 1)
      //     .map((item) => item.Amount)
      //     .reduce((prev, curr) => new Decimal(prev).plus(curr).toNumber(), 0)
      // );

      return charged;
    },
    TotalchargedinMoth() {
      const chargedInMonth =
        this.registers.length > 0 ? this.registers[0].Cobrados_del_mes : 0;
      // const charged = Math.abs(
      //   this.registers
      //     .filter((kpi) => kpi.DocumentType == 1)
      //     .map((item) => item.Amount)
      //     .reduce((prev, curr) => new Decimal(prev).plus(curr).toNumber(), 0)
      // );

      return chargedInMonth;
    },
    Totalpastcharged() {
      const Pastcharged =
        this.registers.length > 0 ? this.registers[0].CobradosAnteriores : 0;
      // const charged = Math.abs(
      //   this.registers
      //     .filter((kpi) => kpi.DocumentType == 1)
      //     .map((item) => item.Amount)
      //     .reduce((prev, curr) => new Decimal(prev).plus(curr).toNumber(), 0)
      // );

      return Pastcharged;
    },
    TotalchargedThisMonthFromPastFacts() {
      const chargedThisMonthFromPast =
        this.registers.length > 0
          ? this.registers[0].Cobrados_de_otros_meses
          : 0;
      // const charged = Math.abs(
      //   this.registers
      //     .filter((kpi) => kpi.DocumentType == 1)
      //     .map((item) => item.Amount)
      //     .reduce((prev, curr) => new Decimal(prev).plus(curr).toNumber(), 0)
      // );

      return chargedThisMonthFromPast;
    },
    cobradoATiempo() {
      const charged = Math.abs(
        this.registers
          .filter((kpi) => kpi.DocumentTypeKpiCharges == 1)
          .map((item) => item.Amount)
          .reduce((prev, curr) => new Decimal(prev).plus(curr).toNumber(), 0)
      );

      return charged;
    },

    ...mapMutations("my_request", [
      "TOGGLE_GET_MY_REQUEST",
      "SET_TAB_ACTIVE_NAME",
      "SET_TAB_ACTIVE_SECTION_NAME",
      "SET_BY_EMPLOYEE_ID",
      "SET_ALL_MY_REQUESTS",
      "SET_SEARCH",
      "TOGGLE_LOADING",
      "SET_BY_DIRECCTION_ID"
    ]),
    async onCloseDrawer() {
      this.showChartMonth = false;
      this.showChartMonth2 = false;
      this.showChartEjecutiveMonth = false;
      this.showChartEjecutiveMonth2 = false;
      this.quincenaSelected = 0;
    },
    async openDrawer(tab, month) {
      if (!this.$refs) {
        return;
      }
      this.detallesFacturas = true;
      this.tabDrawer = tab;
      this.monthDrawer = month;
      this.cargarFacturasItems();
      if (this.activeName == "charges") {
        if (this.semana) {
          this.showChartMonth2 = true;
        } else {
          this.showChartMonth = true;
        }
      }
    },
    cargarFacturasItems() {
      this.cargandoDetallesFacturas = true;
      const parameters = {
        Year: this.year,
        Month: this.monthToNumber[this.monthDrawer],
        Type: this.tabToType[this.tabDrawer]
      };
      this.$http
        .get("/api/accountsReceivable/allInvoicesDetails", {
          params: parameters
        })
        .then(({ data }) => {
          this.detallesFacturasItems = data;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    ...mapActions({
      fetchCustomers: "customers/getCustomers"
    }),
    async onClientChanging(clientCode) {
      this.clientCode = clientCode;
      this.invoicesByClientLoading = true;
      this.getInvoicesByClient();
    },

    reducer(month) {
      let total = new Decimal(0.0);
      // if (this.activeName === "invoicesPending") {
      //   this.items.forEach((row) => {
      //     if (row[`${month}Amount`]) {
      //       total = total.plus(row[`${month}Amount`]);
      //     }
      //   });
      //   return formatMonto(total.toNumber());
      // }
      this.items.forEach((row) => {
        if (row[month]) {
          total = total.plus(row[month]);
        }
      });
      return formatMonto(total.toNumber());
    },
    avarage(month) {
      let total = new Decimal(0.0);
      this.items.forEach((row) => {
        if (row[month]) {
          total = total.plus(row[month]);
        }
      });
      total = total.div(this.items.length);
      return formatMonto(total.toNumber());
    },
    formatMonto,
    OpenSelection(mes, vendor, name) {
      let codeType = typeof vendor;
      this.ejecutive = vendor;
      this.monthDrawer = mes;
      if (this.activeName == "charges") {
        if (this.semana) {
          this.showChartEjecutiveMonth2 = true;
        } else {
          this.showChartEjecutiveMonth = true;
        }
      }
      mes = mes - 1;
      this.month = GetMonthInLetterBeginingOnZero(mes);
      mes = mes + 1;
      this.cobros = true;
      this.executive = name ?? vendor.Name + " " + vendor.LastName;
      if (codeType == "string") {
        this.getDetailsinfo(vendor, mes, this.year);
      } else {
        this.getDetailsinfo(vendor.Code, mes, this.year);
      }
    },
    OpenEntryDetails(vendor) {
      this.entryDocDrawer = true;
      this.EntryDetails(vendor.EntryNo);
    },
    getType() {
      /*
      if (this.activeName === "invoicesPending") {
        return this.type;
      } else
      */
      if (this.activeName === "KpiCharges") {
        return (this.type = "Cantidad");
      } else {
        return (this.type = "Monto");
      }
    },
    onSubmit() {
      var data = {
        OldDate: this.form.currentdate,
        PromiseDate: this.form.newdate,
        CustomerCode: this.AccountNumber,
        Amount: this.Amount,
        Motive: this.form.comment,
        CompanyID: this.currentCompany,
        User: this.currentUser.FullName,
        InvoiceNum: this.invoiceNum,
        ContactName: this.form.contactData.FullName,
        ContactEmail: this.form.contactData.Email,
        ContactNumber: this.form.contactData.PhoneNumber,
        ContactCode: this.form.contactData.Code
      };
      this.handleButtonLoading = true;

      this.$http
        .post("/api/AccountsReceivable/ChangeDataFromDueDateToFutureDate", data)
        .then(({ data }) => {
          if (data) {
            this.formpayment = false;
            if (data.AddInteraction) {
              let msg =
                "Se ha creado una interacion con este compromiso de pago";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  title: "Creacion de Interacion",
                  position: "top-left"
                });
              }, 1500);
            }
            if (data.NotifyCustomer) {
              let msg = "El contacto ha sido notificado via correo";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  offset: 10,
                  title: "Notificacion a cliente",
                  position: "top-left"
                });
              }, 1500);
            }
            if (data.CashFlowModify) {
              let msg =
                "Se ha creado un movimiento en cashflow con este compromiso";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  offset: 20,
                  title: "Registro en cashflow",
                  position: "top-left"
                });
              }, 1500);
            }
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.handleButtonLoading = false;
          this.getDetailsinfo(
            this.selectedRow.VendorCode,
            new Date(this.selectedRow.PostingDate).getMonth() + 1,
            this.year
          );
          this.handleClose();
        });
    },
    handler_year(_year) {
      this.year = _year;
      switch (this.activeName) {
        case "invoicesByClient":
          this.invoicesByClientLoading = true;
          this.getInvoicesByClient();
          break;
        case "invoices":
          this.principalTable = true;
          this.getData();
          break;
        case "charges":
          this.disableLoading = true;
          this.getDataCharged();
          break;
        case "invoicesPending":
          this.pendingLoading = true;
          this.getDataPending();
          break;
        case "KpiCharges":
          this.kpiLoading = true;
          this.getKPI();
          break;
        default:
          break;
      }
    },
    handleClose() {
      this.form.currentdate = "";
      this.form.newdate = "";
      this.form.comment = "";
      this.form.contactCode = "";
      this.AccountNumber = "";
      this.Amount = "";
      this.InvoiceNum = "";
      this.ContactEmail = "";
      this.form.contactEmail = "";
      this.form.contactNumber = "";
      this.form.contactName = "";
      this.form.contactPhoneNumber = "";
      this.selectedRow = {};
      this.formpayment = false;
    },
    HandlerAction(action) {
      const { command } = action;
      const { CustomerNo, PostingDate, DocumentNo } = action.row;

      this.Amount = action.row.Amount;
      this.AccountNumber = CustomerNo;
      this.invoiceNum = DocumentNo;
      this.OldDate = PostingDate;

      switch (command) {
        case "view-customer":
          this.handleClickViewClient(action.row.CustomerNo);
          break;
        case "change-date-payment":
          this.formpayment = true;
          this.selectedRow = action.row;
          this.form.currentdate = PostingDate;
          this.getContactsByCustomerCode(CustomerNo);
          break;
        case "see-comments":
          this.Dcoments = true;
          this.getcomments(CustomerNo);
          break;
        case "see-comments-payment":
          this.Dcoments = true;
          this.getcomments(CustomerNo, true);
          break;
        default:
          break;
      }
    },
    async handleClickViewClient(clientCode) {
      try {
        const resp = await this.$http.get(`/api/customers/${clientCode}`, {
          params: {
            companyCode: this.currentCompany
          }
        });
        const { data } = resp;
        this.customerDetailData = data;
        if (this.$refs.detailsCustomer && this.$refs.detailsCustomer.show) {
          this.$refs.detailsCustomer.show(data);
        } else {
          console.error("No se pudo abrir el detalle del cliente.");
        }
      } catch (error) {
        console.error("Error al obtener el cliente:", error);
      }
    },

    getcomments(customerCode, onlyPayment = false) {
      let parameters = {
        CustomerCode: customerCode,
        CompanyId: this.currentCompany
      };

      this.commentloading = true;
      this.$http
        .get("/api/interactions/InteractionsCustomerDetails", {
          params: parameters
        })
        .then(({ data }) => {
          data.Items.forEach((row) => {
            if (row.Description) {
              const cleanComment = row.Description.replace(/(<([^>]+)>)/gi, "");
              row.Description = cleanComment;
            }
          });
          this.prospectDetailInteractions = data.Items;
          this.comments = data.Items;
          if (onlyPayment) {
            this.comments = data.Items.filter(
              (comment) => comment.InteractionTemplateCode == "LLAMADAVVC"
            );
            if (this.comments.length <= 0) {
              this.$emit({
                type: "info",
                message: "Sin comentarios de cobro"
              });
            }
          }
        })
        .finally(() => {
          this.commentloading = false;
        });
    },
    getContactsByCustomerCode(customerCode = String) {
      this.loadingContacts = true;
      this.$http
        .get("/api/contacts/GetContactByCustomerCode", {
          params: {
            customerCode: customerCode,
            companyCode: this.currentCompany
          }
        })
        .then(({ data }) => {
          this.contacts = data;
        })
        .catch((err) => {
          this.$message.error(
            `no se pudieron tener contacto sobre este cliente ${err}`
          );
        })
        .finally(() => {
          this.loadingContacts = false;
        });
    },
    handlerChanges() {
      switch (this.activeName) {
        case "invoices":
          this.principalTable = true;
          this.getData();
          break;
        case "charges":
          this.disableLoading = true;
          this.getDataCharged();
          break;
        case "invoicesByClient":
          this.invoicesByClientLoading = true;
          this.getInvoicesByClient();
          break;
        case "invoicesPending":
          this.kpiLoading = true;
          this.getKPI();
          break;
        case "KpiCharges":
          this.kpiLoading = true;
          this.getKPI();
          break;
        default:
          break;
      }
      //this.getData();
      // this.getDataCharged();
      //this.getDataPending();
    },
    // getDetailsinfo(code, month = Number, year = Number) {
    //   this.loadingDetails = true;
    //   this.$http
    //     .get(`/api/accountsReceivable/PeddingPaymentDetails`, {
    //       params: {
    //         ExecutiveCode: code,
    //         month: month,
    //         year: year,
    //         CompanyId: this.currentCompany,
    //         typeAgent: this.TypeAgent
    //       }
    //     })
    //     .then(({ data }) => {
    //       this.registers = data;
    //       this.loadingDetails = false;
    //     })
    //     .catch(error => {
    //       this.$message.error("Error al consultar los Registros");
    //       console.error(error);
    //     })
    //     .finally(() => {
    //       this.loadingDetails = false;
    //     });
    // },
    async getData() {
      this.principalTable = true;
      this.disablePendingTab = true;
      this.disableKpiTab = true;
      this.disableChargeTab = true;
      this.disableInvoiceByClientTab = true;
      // const axiosSource = axios.CancelToken.source();
      // if (this.request) {
      //   this.request.cancel();
      //   this.request = null;
      // }

      // this.request = {
      //   cancel: axiosSource.cancel,
      //   msg: "Loading...",
      //   loading: true
      // };
      this.kpiLoading = true;

      const params = {
        typeAgent: this.TypeAgent,
        year: this.year,
        companyId: this.currentCompany
      };

      this.$http
        .get("/api/accountsReceivable/InvoicedByMothByExecutive", {
          timeout: 9000 * 100,
          params: params
        })
        .then(({ data }) => {
          this.items = data;
          this.itemsInvoices = data;
          //this.request.loading = false;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.principalTable = false;
          this.disablePendingTab = false;
          this.disableKpiTab = false;
          this.disableChargeTab = false;
          this.disableInvoiceByClientTab = false;
          this.kpiLoading = true;
        });
    },
    async getInvoicesByClient() {
      this.items = [];

      this.disablePendingTab = true;
      this.disableKpiTab = true;
      this.disableChargeTab = true;
      this.disableInvoiceByClientTab = true;
      const params = {
        year: this.year,
        companyId: this.currentCompany,
        ClientCode: this.clientCode,
        Producto: this.Producto
      };

      this.$http
        .get("/api/accountsReceivable/InvoicedByMonthByClient", {
          timeout: 9000 * 100,
          params: params
        })
        .then(({ data }) => {
          this.items = data;
          this.itemsInvoicesByClient = data;
          //this.request.loading = false;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.principalTable = false;
          this.disablePendingTab = false;
          this.disableKpiTab = false;
          this.disableChargeTab = false;
          this.disableInvoiceByClientTab = false;
          this.invoicesByClientLoading = false;
        });
    },
    async getDataCharged() {
      // const axiosSource = axios.CancelToken.source();
      // if (this.request) {
      //   this.request.cancel();
      //   this.request = null;
      // }

      // this.request = {
      //   cancel: axiosSource.cancel,
      //   msg: "Loading...",
      //   loading: true
      // };
      this.disableLoading = true;
      this.disablePendingTab = true;
      this.disableKpiTab = true;
      this.disableInvoiceTab = true;
      this.disableInvoiceByClientTab = true;

      const params = {
        typeAgent: this.TypeAgent,
        year: this.year,
        companyId: this.currentCompany
      };

      this.$http
        .get("/api/accountsReceivable/BillsChargedByMonth", {
          timeout: 9000 * 100,
          params: params
        })
        .then(({ data }) => {
          this.items = data;
          this.itemsCharged = data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.disableLoading = false;
          this.disablePendingTab = false;
          this.disableKpiTab = false;
          this.disableInvoiceTab = false;
          this.disableInvoiceByClientTab = false;
        });
    },
    async getDataPending() {
      // const axiosSource = axios.CancelToken.source();
      // if (this.request) {
      //   this.request.cancel();
      //   this.request = null;
      // }

      // this.request = {
      //   cancel: axiosSource.cancel,
      //   msg: "Loading...",
      //   loading: true
      // };
      this.pendingLoading = true;
      this.disableChargeTab = true;
      this.disableKpiTab = true;
      this.disableInvoiceTab = true;
      this.disableInvoiceByClientTab = true;

      const params = {
        typeAgent: this.TypeAgent,
        year: this.year,
        companyId: this.currentCompany
      };

      this.$http
        .get("/api/accountsReceivable/paymentmaster2", {
          timeout: 9000 * 100,
          params: params
        })
        .then(({ data }) => {
          this.itemsPending = data;
          this.items = data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.pendingLoading = false;
          this.disableChargeTab = false;
          this.disableKpiTab = false;
          this.disableInvoiceTab = false;
          this.disableInvoiceByClientTab = false;
        });
    },
    async getKPI() {
      // const axiosSource = axios.CancelToken.source();
      // if (this.request) {
      //   this.request.cancel();
      //   this.request = null;
      // }

      // this.request = {
      //   cancel: axiosSource.cancel,
      //   msg: "Loading...",
      //   loading: true
      // };
      this.kpiLoading = true;
      this.disableChargeTab = true;
      this.disableInvoiceTab = true;
      this.disableInvoiceByClientTab = true;
      this.disablePendingTab = true;

      const params = {
        typeAgent: this.TypeAgent,
        year: this.year,
        companyId: this.currentCompany
      };

      this.$http
        .get("/api/accountsReceivable/BillsChargedKPI", {
          timeout: 9000 * 100,
          params: params
        })
        .then(({ data }) => {
          this.items = data;
          this.itemsKpi = data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.kpiLoading = false;
          this.disableChargeTab = false;
          this.disableInvoiceTab = false;
          this.disableInvoiceByClientTab = false;
          this.disablePendingTab = false;
        });
    },
    handleTabClick() {
      let self = this;
      this.$nextTick(() => {
        switch (self.activeName) {
          case "invoicesByClient":
            if (this.itemsInvoicesByClient.length > 0) {
              this.items = this.itemsInvoicesByClient;
            } else {
              this.invoicesByClientLoading = true;
              this.items = [];
              this.fetchCustomers();

              this.getInvoicesByClient();
            }
            this.ShowHideFilters(self.activeName);
            break;
          case "invoices":
            if (this.itemsInvoices.length > 0) {
              this.items = this.itemsInvoices;
            } else {
              this.principalTable = true;
              this.items = [];
              this.getData();
            }
            this.ShowHideFilters(self.activeName);
            break;
          case "charges":
            if (this.itemsCharged.length > 0) {
              this.items = this.itemsCharged;
            } else {
              this.disableLoading = true;
              this.items = [];
              this.getDataCharged();
            }
            this.ShowHideFilters(self.activeName);
            break;
          case "invoicesPending":
            if (this.itemsPending.length > 0) {
              this.items = this.itemsPending;
            } else {
              this.pendingLoading = true;
              this.items = [];
              this.getDataPending();
            }
            this.ShowHideFilters(self.activeName);
            break;
          case "KpiCharges":
            if (this.itemsKpi.length > 0) {
              this.items = this.itemsKpi;
            } else {
              this.principalTable = true;
              this.items = [];
              this.getKPI();
            }
            this.ShowHideFilters(self.activeName);
            break;
          default:
            break;
        }
      });
    },
    EntryDetails(entry) {
      this.loadingDetails = true;
      let uri = `/api/accountsReceivable/EntryDocumentDetails`;

      this.$http
        .get(uri, {
          params: {
            ExecutiveCode: entry,
            CompanyId: this.currentCompany,
            typeAgent: this.TypeAgent
          }
        })
        .then(({ data }) => {
          this.itemEntryDetails = [];
          this.itemEntryDetails = data;
          this.loadingDetails = false;
        })
        .catch((error) => {
          this.$message.error("Error al consultar los Registros");
          console.error(error);
        })
        .finally(() => {
          this.loadingDetails = false;
        });
    },
    getDetailsinfo(code, month = Number, year = Number) {
      let uri;

      switch (this.activeName) {
        case "invoices":
          this.datailTitle = "Facturados";
          uri = `/api/accountsReceivable/InvoicedByMothByExecutiveDetails`;
          break;
        case "charges":
          this.datailTitle = "Cobrados";
          uri = `/api/accountsReceivable/BillsChargedByMonthDetails`;
          break;
        case "invoicesPending":
          this.datailTitle = "Pendientes";
          uri = `/api/accountsReceivable/PeddingPaymentDetails2`;
          break;
        case "KpiCharges":
          this.datailTitle = "KPI de Cobros";
          uri = `/api/accountsReceivable/BillsChargedKPIDetails`;
          break;
        default:
          break;
      }
      this.loadingDetails = true;
      this.$http
        .get(uri, {
          params: {
            ExecutiveCode: code,
            month: month,
            year: year,
            CompanyId: this.currentCompany,
            typeAgent: this.TypeAgent
          }
        })
        .then(({ data }) => {
          this.registers = [];

          data.forEach((row) => {
            if (row.LatestComment) {
              const cleanComment = row.LatestComment.replace(
                /(<([^>]+)>)/gi,
                ""
              );
              row.LatestComment = cleanComment;
            }
          });
          this.registers = data;
          switch (this.activeName) {
            case "invoices":
              this.columnsDetails2 = invoicesColumns(this);
              break;
            case "charges":
              this.columnsDetails2 = chargesColumns(this);
              break;
            case "invoicesPending":
              this.columnsDetails2 = pendingColumns(this);
              break;
            case "KpiCharges":
              this.columnsDetails2 = KpiChargesColumns(this);
              break;
            default:
              break;
          }
          this.loadingDetails = false;
        })
        .catch((error) => {
          this.$message.error("Error al consultar los Registros");
          console.error(error);
          this.loadingDetails = false;
        });
    },

    ShowHideFilters(val) {
      const getValType = typeof val;
      if (getValType === "string") {
        if (val == "invoicesPending") {
          this.invoicesPending = true;
        } else {
          this.invoicesPending = false;
        }
      } else {
        this.invoicesPending = false;
      }
    },

    handleContactSelect(contact) {
      this.form.contactData = contact;
      this.form.contactName = contact.FullName;
      this.form.contactEmail = contact.Email;
      this.form.contactNumber = contact.MobilePhoneNumber;
      this.form.contactPhoneNumber = contact.PhoneNumber;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Procentajes promedios";
          return;
        }

        let col = column.property;
        /*
        if (this.type === "Monto") {
          col = `${column.property}Amount`;
        }
        */
        const values = data.map((item) => Number(item[col]));
        if (!values.every((value) => isNaN(value))) {
          let val = values
            .reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
            .toFixed(2);

          if (this.type === "Monto") {
            val = formatMonto(val);
            sums[index] = val;
          } else {
            sums[index] = (val / values.length).toFixed(2) + " %";
          }
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    getSummariesMontos(param /*, datos*/) {
      let { columns, data } = param;
      let sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        let col = column.property;
        /*
        if (/*this.type === "Monto" &&/ this.activeName === "invoicesPending") {
          col = `${column.property}Amount`;
        }*/
        let values = data.map((item) => Number(item[col]));
        if (!values.every((value) => isNaN(value))) {
          let val = values.reduce((prev, curr) => {
            let value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (this.type === "Monto") {
            val = formatMonto(val);
            sums[index] = val;
          } else {
            sums[index] = val;
          }
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    onQuincenaSelected(quincena) {
      this.quincenaSelected = quincena;
      this.getData();
    },

    parseMonto(value) {
      if (typeof value === "number") return value;

      return Number(String(value || "").replace(/[^0-9.-]/g, ""));
    },

    sortMonto(a, b) {
      return this.parseMonto(a) - this.parseMonto(b);
    },

    ExcelExport() {
      let columns = [];
      let rows = [];
      let bookTilte = "";

      switch (this.activeName) {
        case "invoices":
          columns = this.columnsCharged.map((column) => {
            return column.label;
          });

          rows = this.items.map((item) => {
            return [
              item.ExecutiveName + " " + item.LastName,
              item.January,
              item.February,
              item.March,
              item.April,
              item.May,
              item.June,
              item.July,
              item.August,
              item.September,
              item.October,
              item.November,
              item.December,
              item.Totals
            ];
          });

          bookTilte = "Facturado por Mes";

          break;
        case "invoicesByClient":
          columns = this.invoiceByClientColumns.map((column) => {
            return column.label;
          });

          rows = this.items.map((item) => {
            return [
              item.ClientCode,
              item.ClientName,
              item.January,
              item.February,
              item.March,
              item.April,
              item.May,
              item.June,
              item.July,
              item.August,
              item.September,
              item.October,
              item.November,
              item.December,
              item.Totals,
              item.ClientReceivable,
              item.ClientService,
              item.SalesPerson
            ];
          });

          bookTilte = "Facturado por cliente Mensual";

          break;

        case "charges":
          columns = this.columnsCharged.map((column) => {
            return column.label;
          });

          rows = this.items.map((item) => {
            return [
              item.ExecutiveName + " " + item.LastName,
              item.January,
              item.February,
              item.March,
              item.April,
              item.May,
              item.June,
              item.July,
              item.August,
              item.September,
              item.October,
              item.November,
              item.December,
              item.Totals
            ];
          });

          bookTilte = "Cobrado por Mes";

          break;

        case "invoicesPending":
          // console.log("invoices: ",this.itemsPending)
          // console.log("invoicesColumns: ", this.columnsCharged)

          columns = this.columnsCharged.map((column) => {
            return column.label;
          });

          rows = this.itemsPending.map((item) => {
            return [
              item.ExecutiveName + " " + item.LastName,
              item.January,
              item.February,
              item.March,
              item.April,
              item.May,
              item.June,
              item.July,
              item.August,
              item.September,
              item.October,
              item.November,
              item.December,
              item.Totals
            ];
          });

          bookTilte = "Pendiente por Mes";

          break;
        case "KpiCharges":
          columns = KpiChargesColumns(this).map((column) => {
            return column.label;
          });

          rows = this.items.map((item) => {
            return [
              item.Name + " " + item.LastName,
              item.January,
              item.February,
              item.March,
              item.April,
              item.May,
              item.June,
              item.July,
              item.August,
              item.September,
              item.October,
              item.November,
              item.December,
              item.Totals
            ];
          });

          bookTilte = "KPI de corbos por Mes";

          break;
        default:
          break;
      }

      exportExcel(columns, rows, bookTilte);

      // let columnNames = this.columns
      //   .map((column) => {
      //     return column.name;
      //   })
      //   .concat(["Cédula", "Ingreso", "Cumpleaños"]);
      // let columnsData = this.items.map((item) => {
      //   return [
      //     item.Name,
      //     item.Direccion.Name,
      //     item.Deparmento.Name,
      //     item.Posicion.Name,
      //     item.Supervisor.Name,
      //     item.Email,
      //     item.Fleet,
      //     item.Extension,
      //     item.No_Pase,
      //     FormatCedula(item.DocumentNumber),
      //     item.StartDate.slice(0, 10),
      //     item.DateOfBirth.slice(0, 10)
      //   ];
      // });
      // let fileTitle = "Lista de Empleados";

      // await exportExcel(columnNames, columnsData, fileTitle);
    },
    async OnExecutiveSelected(executiveTypeSelected) {
      this.TypeAgent = executiveTypeSelected;
      switch (this.activeName) {
        case "invoices": {
          await this.getData();
          break;
        }
        case "invoicesByClient": {
          await this.getInvoicesByClient();
          break;
        }
        case "charges": {
          this.changingShow = !this.changingShow;
          await this.getDataCharged();
          break;
        }
        case "invoicesPending": {
          await this.getDataPending();
          break;
        }
        case "KpiCharges": {
          await this.getKPI();
          break;
        }
      }
    }
  }
};
</script>

<style scoped>
.pointer .el-input.is-disabled .el-input__inner {
  cursor: pointer;
}
.supliers_select {
  min-width: 60%;
}
#table-card td {
  padding-left: 1px;
}
.col-p {
  padding: 5px;
  box-sizing: border-box;
}
.month-summary {
  display: grid;
  width: 90%;
  grid-template-columns: repeat(4, 3fr);
  grid-row-gap: 0px;
}
.month-summary span {
  padding: 0px;
  display: flex;
  align-items: center;
}
.month-summary span h3 {
  margin: 2px;
  margin-right: 10px;
}
.month-summary span a {
  font-weight: 700;
}

.contenedor-flex {
  display: flex;
}
.item {
  padding: 10px;
  background-color: lightblue;
}
</style>
